import { render, staticRenderFns } from "./FeedbackIndex.vue?vue&type=template&id=7d7d96a2&lang=pug"
import script from "./FeedbackIndex.vue?vue&type=script&lang=js"
export * from "./FeedbackIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports